/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Placeholder_3Inputs */

const en_try_magic_placeholder_3 = /** @type {(inputs: Try_Magic_Placeholder_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your story...`)
};

const es_try_magic_placeholder_3 = /** @type {(inputs: Try_Magic_Placeholder_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu historia...`)
};

/**
* | output |
* | --- |
* | "Write your story..." |
*
* @param {Try_Magic_Placeholder_3Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_placeholder_3 = /** @type {((inputs?: Try_Magic_Placeholder_3Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Placeholder_3Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_placeholder_3(inputs)
	return en_try_magic_placeholder_3(inputs)
});